<template>
  <div
    :class="{
      'form-group--error': typeof validate !== 'undefined' && validate.$error,
      'form-group': hasGroup,
    }"
  >
    <label v-if="labelShown" :for="id">
      {{ label }}
      <span class="text-danger" v-if="isRequired"> * </span>
    </label>
    <div>
      <Textarea
        :id="id"
        ref="inputField"
        :disabled="disabled"
        :placeholder="placeholder"
        :autofocus="autofocus"
        v-model="inputValue"
        :rows="rows"
        :cols="cols"
        :autoResize="autoResize"
        :class="[
          { 'p-invalid': typeof validate !== 'undefined' && validate.$error },
          inputClass,
        ]"
      />
    </div>
    <BaseFormMessage
      v-if="typeof validate !== 'undefined'"
      :validate="validate"
      :label="label"
      :baseErrorClass="baseErrorClass"
    />
  </div>
</template>

<script>
import Textarea from "primevue/textarea";
export default {
  components: {
    Textarea,
  },
  props: {
    autofocus: {
      type: Boolean,
      required: false,
    },
    id: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    value: {
      type: [String, Number],
      default: "",
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    hasGroup: {
      type: Boolean,
      default: true,
    },
    validate: {
      type: Object,
      default: () => {
        // This is intentional
      },
    },
    placeholder: {
      type: String,
      default: "",
    },
    rows: {
      type: String,
    },
    cols: {
      type: String,
    },
    autoResize: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    inputClass: {
      type: String,
      required: false,
    },
    labelShown: {
      type: Boolean,
      default: false,
    },
    baseErrorClass: {
      type: String,
      required: false,
    },
  },
  computed: {
    inputValue: {
      get: function () {
        return this.value;
      },
      // setter
      set: function (newValue) {
        this.$emit("input", newValue);
      },
    },
  },
};
</script>
